// Período, categoria e tipo — filtros que valem para plantios e espécies.
export default function FiltrosPlantio({ valores, onChange }) {
  return (
    <>
      <div className="campo">
        <label htmlFor={`de-${valores.id}`}>De</label>
        <input id={`de-${valores.id}`} type="date" value={valores.de} max={valores.ate || undefined}
          onChange={(e) => onChange({ de: e.target.value })} />
      </div>
      <div className="campo">
        <label htmlFor={`ate-${valores.id}`}>Até</label>
        <input id={`ate-${valores.id}`} type="date" value={valores.ate} min={valores.de || undefined}
          onChange={(e) => onChange({ ate: e.target.value })} />
      </div>
      <div className="campo">
        <label htmlFor={`categoria-${valores.id}`}>Categoria</label>
        <select id={`categoria-${valores.id}`} value={valores.tipo_categoria} onChange={(e) => onChange({ tipo_categoria: e.target.value })}>
          <option value="">Todas</option>
          <option value="Individual">Individual</option>
          <option value="Profissional">Profissional (áreas)</option>
        </select>
      </div>
      <div className="campo">
        <label htmlFor={`tipo-${valores.id}`}>Tipo de plantio</label>
        <select id={`tipo-${valores.id}`} value={valores.tipo} onChange={(e) => onChange({ tipo: e.target.value })}>
          <option value="">Todos</option>
          <option value="Pessoal">Pessoal</option>
          <option value="Organizacional">Organizacional</option>
          <option value="Empresarial">Empresarial</option>
        </select>
      </div>
    </>
  );
}
